import { render, staticRenderFns } from "./ViewModel.vue?vue&type=template&id=0e188a84&scoped=true&"
import script from "./ViewModel.vue?vue&type=script&lang=js&"
export * from "./ViewModel.vue?vue&type=script&lang=js&"
import style0 from "./ViewModel.vue?vue&type=style&index=0&id=0e188a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e188a84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VFlex,VSkeletonLoader})
